module.exports = __webpack_public_path__ + "img/cart.c72b5baf.png";